import { RtcTokenBuilder, RtcRole } from 'agora-access-token';
import { useState, useEffect } from 'react';
import AgoraRTC from 'agora-rtc-sdk-ng';

export function generateToken(appId = "", appCertificate = "", roomId = "", userId = "") {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const expirationTimeInSeconds = 3600;
    const privilegeExpiredTs = currentTimestamp + expirationTimeInSeconds;

    try {
        const token = RtcTokenBuilder.buildTokenWithUid(
            appId,
            appCertificate,
            roomId,
            userId,
            RtcRole.PUBLISHER,
            privilegeExpiredTs
        );

        return token;
    } catch (error) {
        //console.log(error);
        return null;
    }
}

export function useAgora(client) {
    const [localVideoTrack, setLocalVideoTrack] = useState(undefined);
    const [localAudioTrack, setLocalAudioTrack] = useState(undefined);

    const [joinState, setJoinState] = useState(false);

    const [remoteUsers, setRemoteUsers] = useState([]);

    async function createLocalTracks(audioConfig, videoConfig) {
        const [microphoneTrack, cameraTrack] = await AgoraRTC.createMicrophoneAndCameraTracks(audioConfig, videoConfig);
        setLocalAudioTrack(microphoneTrack);
        setLocalVideoTrack(cameraTrack);
        return [microphoneTrack, cameraTrack];
    }
    async function join(appid, channel, token, uid = '') {
        if (!client) return;
        const [microphoneTrack, cameraTrack] = await createLocalTracks();

        await client.join(appid, channel, token || null, uid);
        await client.publish([microphoneTrack, cameraTrack]);

        //(window as any).client = client;
        //(window as any).videoTrack = cameraTrack;
        setJoinState(true);
    }

    async function startScreenShare(appid, channel, token, uid = ''){
        if (!client) return;
        const screenClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
        await screenClient.join(appid, channel, token, uid);

        const screenTrack = await AgoraRTC.createScreenVideoTrack();
        await screenClient.publish(screenTrack);

        return screenClient;
    }

    async function leave() {
        if (localAudioTrack) {
            localAudioTrack.stop();
            localAudioTrack.close();
        }
        if (localVideoTrack) {
            localVideoTrack.stop();
            localVideoTrack.close();
        }
        setRemoteUsers([]);
        setJoinState(false);
        await client?.leave();
    }

    useEffect(() => {
        if (!client) return;
        setRemoteUsers(client.remoteUsers);

        const handleUserPublished = async (user, mediaType) => {
            await client.subscribe(user, mediaType);
            // toggle rerender while state of remoteUsers changed.
            setRemoteUsers(remoteUsers => Array.from(client.remoteUsers));
        }
        const handleUserUnpublished = (user) => {
            setRemoteUsers(remoteUsers => Array.from(client.remoteUsers));
        }
        const handleUserJoined = (user) => {
            setRemoteUsers(remoteUsers => Array.from(client.remoteUsers));
        }
        const handleUserLeft = (user) => {
            setRemoteUsers(remoteUsers => Array.from(client.remoteUsers));
        }
        client.on('user-published', handleUserPublished);
        client.on('user-unpublished', handleUserUnpublished);
        client.on('user-joined', handleUserJoined);
        client.on('user-left', handleUserLeft);

        return () => {
            client.off('user-published', handleUserPublished);
            client.off('user-unpublished', handleUserUnpublished);
            client.off('user-joined', handleUserJoined);
            client.off('user-left', handleUserLeft);
        };
    }, [client]);

    return {
        localAudioTrack,
        localVideoTrack,
        joinState,
        leave,
        join,
        remoteUsers,
        startScreenShare
    };
}